import {
  UPDATE_TENANT_DETAILS_REQUEST,
  UPDATE_TENANT_DETAILS_SUCCESS,
  UPDATE_TENANT_DETAILS_FAILURE,
  RESET_TENANT_DETAILS_SUCCESS,
} from "../../../Constants/actionTypes";

import { API_TENANT_DETAILS } from "../../../Constants/apiUrls";

export const resetOnSuccess = () => ({
  type: RESET_TENANT_DETAILS_SUCCESS,
});

// ✅ Read response body ONCE (works for json or plain text)
const readBody = async (res) => {
  const text = await res.text();
  if (!text) return { json: null, text: "" };

  try {
    return { json: JSON.parse(text), text };
  } catch {
    return { json: null, text };
  }
};

const pickError = ({ json, text }) =>
  json?.error || json?.message || json?.msg || (text?.trim() ? text : "Unknown Error");

const pickSuccess = ({ json, text }) =>
  json || { message: text || "Tenant details updated successfully" };

const doTenantRequest = (method) => (tenantDetails) => async (dispatch, getState) => {
  dispatch({ type: UPDATE_TENANT_DETAILS_REQUEST });

  const token = getState()?.auth?.accessToken;

  try {
    const res = await fetch(API_TENANT_DETAILS, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(tenantDetails),
    });

    const parsed = await readBody(res);

    if (res.ok) {
      dispatch({ type: UPDATE_TENANT_DETAILS_SUCCESS, payload: pickSuccess(parsed) });
    } else {
      dispatch({ type: UPDATE_TENANT_DETAILS_FAILURE, payload: pickError(parsed) });
    }
  } catch (error) {
    const msg =
      error?.message === "Failed to fetch" || String(error?.message || "").includes("NetworkError")
        ? "Server is currently down. Please try again later."
        : error?.message || "Unknown Error";

    dispatch({ type: UPDATE_TENANT_DETAILS_FAILURE, payload: msg });
  }
};

// ✅ Keep your existing API design:
export const addTenantDetails = doTenantRequest("PATCH");
export const updateTenantDetails = doTenantRequest("PATCH"); // or PATCH if backend supports upsert
